import { Box, Stack, Tooltip } from "@chakra-ui/react";
import { Link } from "@ui/components/link/link";
import { IconTab_T } from "./premium-sidebar";

export const IconTab = (props: IconTab_T & { pathname: string }) => {
  const { icon: Icon, label, href, pathname } = props;
  const selectedColor = "blue.600";
  return (
    <Stack
      as={Link}
      href={href}
      w="100%"
      h={"14"}
      py="1.5"
      bg={pathname === href ? selectedColor : "blue.500"}
      _hover={{ bg: selectedColor }}
      justifyContent="center"
      alignItems="center"
    >
      <Tooltip
        label={label}
        shouldWrapChildren
        hasArrow
        placement="top"
        offset={[0, 12]}
      >
        <Box as={Icon} w="100%" h="8" py="auto" px="0" color="white" />
      </Tooltip>
    </Stack>
  );
};
